import { render, staticRenderFns } from "./InformantDlg.vue?vue&type=template&id=2fc440fa&"
import script from "./InformantDlg.vue?vue&type=script&lang=ts&"
export * from "./InformantDlg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports